"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
var _getApolloRestClient = require("./getApolloRestClient");
var _logger = _interopRequireDefault(require("./logger"));
const QUERY = "\n  query resetPassword {\n    resetPassword @rest(path: \"\") {\n      ticket\n    }\n  }\n";
const fetchLinkForResetPassword = async _ref => {
  let {
    bffUrl
  } = _ref;
  const bannerRepositoryUrl = "".concat(bffUrl, "/navigation/reset-password");
  const client = (0, _getApolloRestClient.getApolloRestClient)(bannerRepositoryUrl);
  const query = (0, _client.gql)(QUERY);
  return client.query({
    query,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }).then(response => {
    const {
      ticket
    } = response.data.resetPassword;

    // if banner is not displayed, then modal is not displayed
    if (!ticket) {
      const stringifiedResponse = JSON.stringify(response);
      _logger.default.error('Error fetching link for rest password', stringifiedResponse);
      throw new Error(stringifiedResponse);
    }
    return ticket;
  }).catch(err => {
    _logger.default.error('Error fetching link for rest password', err);
    throw err;
  });
};
var _default = exports.default = fetchLinkForResetPassword;